import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = { class: "what-now" }
const _hoisted_3 = { class: "btn-links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9 0V9H0V11H9V20H11V11H20V9H11V0H9Z",
    fill: "#6C6C6C"
  })
], -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Add New", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "preview-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["active-links center", { 'no-scroll': $setup.noScroll }])
  }, [
    _createVNode($setup["VTabs"], {
      class: "links-tabs",
      modelValue: $setup.tabIndex,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tabIndex) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode($setup["VTab"], {
          selectedTitle: "Meeting Types",
          title: "Invites"
        }, {
          default: _withCtx(() => [
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode($setup["Loader"])
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userInviteLinks, (invite) => {
              return (_openBlock(), _createBlock($setup["InviteLink"], {
                class: "link",
                invite: invite,
                onOpenPopup: ($event: any) => ($setup.openPopup(invite)),
                onOpenSharePopup: ($event: any) => ($setup.openSharePopup(invite))
              }, null, 8 /* PROPS */, ["invite", "onOpenPopup", "onOpenSharePopup"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showVideo = true))
      }, "What do I do now?")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "borderless",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo('/')))
      }, "Back"),
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goTo('/new-invite')))
      }, _hoisted_6)
    ]),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[5] || (_cache[5] = ($event: any) => ($setup.noScroll = true)),
      onAfterEnter: _cache[6] || (_cache[6] = ($event: any) => ($setup.noScroll = false)),
      onBeforeLeave: _cache[7] || (_cache[7] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => ($setup.noScroll = false))
    }, {
      default: _withCtx(() => [
        ($setup.showPreview && $setup.selectedLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode($setup["OptOffer"], {
                offerLink: $setup.selectedLink.link,
                "is-preview": true,
                onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showPreview = false))
              }, null, 8 /* PROPS */, ["offerLink"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode($setup["Toast"], {
      time: 5000,
      showToast: $setup.showToast,
      message: $setup.toastMessage,
      onCloseToast: _cache[9] || (_cache[9] = ($event: any) => ($setup.showToast = false))
    }, null, 8 /* PROPS */, ["showToast", "message"]),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[13] || (_cache[13] = ($event: any) => ($setup.noScroll = true)),
      onAfterEnter: _cache[14] || (_cache[14] = ($event: any) => ($setup.noScroll = false)),
      onBeforeLeave: _cache[15] || (_cache[15] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[16] || (_cache[16] = ($event: any) => ($setup.noScroll = false))
    }, {
      default: _withCtx(() => [
        ($setup.selectedLink && $setup.showPopup)
          ? (_openBlock(), _createBlock($setup["MeetingLinkPopup"], {
              key: 0,
              selectedLink: $setup.selectedLink,
              onClosePopup: _cache[10] || (_cache[10] = ($event: any) => ($setup.showPopup = false)),
              onShowToast: $setup.handleToast,
              onPreviewInvite: $setup.handlePreview,
              onUpdateInvite: _cache[11] || (_cache[11] = ($event: any) => ($setup.updateInvite($setup.selectedLink!.$id, $event))),
              onToggleActive: _cache[12] || (_cache[12] = ($event: any) => ($setup.updateActive($setup.selectedLink!.$id, $event))),
              onDeleteLink: $setup.deleteLink
            }, null, 8 /* PROPS */, ["selectedLink"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[18] || (_cache[18] = ($event: any) => ($setup.noScroll = true)),
      onAfterEnter: _cache[19] || (_cache[19] = ($event: any) => ($setup.noScroll = false)),
      onBeforeLeave: _cache[20] || (_cache[20] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[21] || (_cache[21] = ($event: any) => ($setup.noScroll = false))
    }, {
      default: _withCtx(() => [
        ($setup.selectedLink && $setup.showSharePopup)
          ? (_openBlock(), _createBlock($setup["MeetingLinkSharePopup"], {
              key: 0,
              selectedLink: $setup.selectedLink,
              onClosePopup: _cache[17] || (_cache[17] = ($event: any) => ($setup.showSharePopup = false)),
              onShowToast: $setup.handleToast,
              onPreviewInvite: $setup.handlePreview
            }, null, 8 /* PROPS */, ["selectedLink"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.showVideo)
      ? (_openBlock(), _createBlock($setup["PopupVideo"], {
          key: 0,
          videoLink: "whatNow",
          onClose: _cache[22] || (_cache[22] = ($event: any) => ($setup.showVideo = false))
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}